'use client';
import React from 'react';
import ProcessCard from './ProcessCard';

const HorizontalProcessFlow = ({ data }) => {
  const { title, description, processes } = data;

  return (
    <div className="w-full flex flex-col items-center gap-16">
      <div className="text-center flex flex-col items-center justify-center">
        <h2 className="text-4xl md:text-5xl lg:text-[60px] font-normal text-center font-title-font text-white mb-4">
          {title}
        </h2>
        <div
          className="text-gray-400 text-lg md:text-xl max-w-3xl text-center"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      <div className="w-full flex flex-wrap gap-8 items-center justify-center">
        {processes?.map((process, index) => (
          <ProcessCard
            key={process.title || index}
            number={index + 1}
            title={process.title}
            description={process.description}
            icon={process.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default HorizontalProcessFlow;
